import { type Locale } from "i18n";
import { createContext, type ReactNode, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { updateIsomorphicRequestData } from "src/lib/isomorphicRequestData/isomorphicRequestDataRef";

export interface LanguageSwitchProviderProps {
  children: ReactNode;
}

export interface LanguageSwitchContextValue {
  availableLocaleOptions: { label: string; locale: string }[];
}

const defaultContextValue = {
  availableLocaleOptions: [
    { label: "EN", locale: "en" },
    { label: "PL", locale: "pl" },
  ],
};

const LanguageSwitchContext =
  createContext<LanguageSwitchContextValue>(defaultContextValue);

export function LanguageSwitchProvider(props: LanguageSwitchProviderProps) {
  const { i18n } = useTranslation();

  useEffect(() => {
    i18n.on("languageChanged", (lng) => {
      document.cookie = `locale=${lng}; path=/; max-age=31536000`;
      updateIsomorphicRequestData({ locale: lng as Locale });
    });
  }, []);
  return (
    <LanguageSwitchContext.Provider value={defaultContextValue}>
      {props.children}
    </LanguageSwitchContext.Provider>
  );
}

export function useLanguageSwitchContext() {
  return useContext(LanguageSwitchContext);
}

export {
  LanguageSwitchButton,
  type LanguageSwitchButtonProps,
} from "./LanguageSwitchButton";
